import { DragableTreeComponent } from './dragable-tree/dragable-tree.component';
import { ExpandableDisplayComponent } from './expandable-display/expandable-display.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MultiNavCategorySelectComponent } from './multi-nav-category-select/multi-nav-category-select.component';
import { SearchableComboboxComponent } from './searchable-combobox/searchable-combobox.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TableComponent } from './table/table.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DateTimeComponent } from './date-time/date-time.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { IpInputComponent } from './ip-input/ip-input.component';
import { RangeInputComponent } from './range-input/range-input.component';
import { TreeViewComponent, ChecklistDatabase } from './tree-view/tree-view.component';
import { MapComponent } from './map/map.component';
// import { AgmCoreModule } from '@agm/core';
import { RecipientListComponent } from './recipient-list/recipient-list.component';
import { GraphGeneratorComponent } from './graph-generator/graph-generator.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ChartViewerComponent } from './chart-viewer/chart-viewer.component';
import { DragNDropChipsComponent } from './drag-ndrop-chips/drag-ndrop-chips.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LoaderComponent } from './loader/loader.component';
import { TabbedNavListComponent } from './tabbed-nav-list/tabbed-nav-list.component';
import { YesNoReasonModalComponent } from './yes-no-reason-modal/yes-no-reason-modal.component';
import { FilesDragAndDropComponent } from './files-drag-and-drop/files-drag-and-drop.component';
import { DateModalComponent } from './date-modal/date-modal.component';
// import { PipesModule } from '@huge-monorepo/hip/tools';
import { ProfileFilesModalComponent } from './profile-files-modal/profile-files-modal.component';
import { DragNDropDirective } from '@huge-monorepo/hip/directives';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { CustomTooltipModule } from '@huge-monorepo/hip/modules';
import { RatingComponent } from './rating/rating.component';
import { MultiAutocompleteComponent } from './multi-autocomplete/multi-autocomplete.component';
import { BotNavComponent } from './modules/bot-nav/bot-nav.component';
import { BasicSearchableComboboxComponent } from './basic-searchable-combobox/basic-searchable-combobox.component';
import { DeviceMapComponent } from './device-map/device-map.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { ApproveRejectComponent } from './approve-reject/approve-reject.component';
import { BreadcrumbModule } from '@huge-monorepo/hip/modules';
import { DirectionsMapComponent } from './directions-map/directions-map.component';
import { GenericDetailsNavComponent } from './generic-details-nav/generic-details-nav.component';
import { StatusTimeAgoComponent } from './status-time-ago/status-time-ago.component';
import { GenericGraphHandlerComponent } from './generic-graph-handler/generic-graph-handler.component';
import { GenericGraphComponent } from './generic-graph/generic-graph.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TimeFrameSelectorComponent } from './time-frame-selector/time-frame-selector.component';
import { CoolButtonComponent } from './cool-button/cool-button.component';
import { NavigationTabComponent } from './navigation-tab/navigation-tab.component';
import { MinimalTableComponent } from './minimal-table/minimal-table.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { ViewpdfModule } from '@huge-monorepo/hip/modules';
import { NewMapComponent } from './new-map/new-map.component';
import { ScheduleMaintenanceDialogComponent } from './schedule-maintenance-dialog/schedule-maintenance-dialog.component';
import { RecipientsModalComponent } from './recipients-modal/recipients-modal.component';
import { InlineRefreshComponent } from './inline-refresh/inline-refresh.component';
import { ReportHeaderComponent } from './report-header/report-header.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { MonthDatePickerComponent } from './month-date-picker/month-date-picker.component';
import { PipesModule } from './pipes/pipes.module';

@NgModule({
  providers: [ChecklistDatabase, DragNDropDirective, { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
  declarations: [
    AdvancedSearchComponent,
    MultiNavCategorySelectComponent,
    SearchableComboboxComponent,
    TableComponent,
    DateRangePickerComponent,
    DateTimeComponent,
    AutocompleteComponent,
    IpInputComponent,
    RangeInputComponent,
    TreeViewComponent,
    MapComponent,
    RecipientListComponent,
    GraphGeneratorComponent,
    ConfirmationDialogComponent,
    ChartViewerComponent,
    DragNDropChipsComponent,
    LoaderComponent,
    TabbedNavListComponent,
    YesNoReasonModalComponent,
    FilesDragAndDropComponent,
    DateModalComponent,
    ProfileFilesModalComponent,
    DragNDropDirective,
    RatingComponent,
    BotNavComponent,
    BasicSearchableComboboxComponent,
    DeviceMapComponent,
    UploadFileComponent,
    ApproveRejectComponent,
    DirectionsMapComponent,
    GenericDetailsNavComponent,
    ExpandableDisplayComponent,
    DragableTreeComponent,
    StatusTimeAgoComponent,
    GenericGraphHandlerComponent,
    GenericGraphComponent,
    TimeFrameSelectorComponent,
    CoolButtonComponent,
    NavigationTabComponent,
    MinimalTableComponent,
    ProgressBarComponent,
    UploadDocumentComponent,
    NewMapComponent,
    ScheduleMaintenanceDialogComponent,
    RecipientsModalComponent,
    InlineRefreshComponent,
    ReportHeaderComponent,
    MonthDatePickerComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    BreadcrumbModule,
    NgxMatSelectSearchModule,
    NgxMaterialTimepickerModule,
    DragDropModule,
    PipesModule,
    // AgmCoreModule.forRoot({
    //   // TODO: Replace with proper key
    //   // apiKey: 'AIzaSyAvJlKHx3CdLrOfNfqA1YrUh3Yxd8KuZsA',
    //   // apiKey: 'AIzaSyBInuEZh-nZ9knZPD4K1pHs91YbdNpyPd8', commented by Damian
    //   apiKey: 'AIzaSyBITMG-4ol5QWGwhCJkKqtw0LZfmTsGa54',
    //   apiVersion: '3.31',
    // }),
    CustomTooltipModule,
    NgApexchartsModule,
    ViewpdfModule,
    MultiAutocompleteComponent,
  ],
  exports: [
    AdvancedSearchComponent,
    MultiNavCategorySelectComponent,
    SearchableComboboxComponent,
    TableComponent,
    DateRangePickerComponent,
    DateTimeComponent,
    AutocompleteComponent,
    IpInputComponent,
    RangeInputComponent,
    TreeViewComponent,
    MapComponent,
    RecipientListComponent,
    GraphGeneratorComponent,
    ConfirmationDialogComponent,
    ChartViewerComponent,
    DragNDropChipsComponent,
    LoaderComponent,
    TabbedNavListComponent,
    DateModalComponent,
    ProfileFilesModalComponent,
    DragNDropDirective,
    FilesDragAndDropComponent,
    RatingComponent,
    MultiAutocompleteComponent,
    BotNavComponent,
    BasicSearchableComboboxComponent,
    UploadFileComponent,
    ApproveRejectComponent,
    DirectionsMapComponent,
    GenericDetailsNavComponent,
    ExpandableDisplayComponent,
    DragableTreeComponent,
    StatusTimeAgoComponent,
    GenericGraphHandlerComponent,
    GenericGraphComponent,
    TimeFrameSelectorComponent,
    CoolButtonComponent,
    NavigationTabComponent,
    MinimalTableComponent,
    ProgressBarComponent,
    UploadDocumentComponent,
    NewMapComponent,
    RecipientsModalComponent,
    InlineRefreshComponent,
    ReportHeaderComponent,
    MonthDatePickerComponent,
  ],
})
export class ToolsModule {}
